module.exports = [{
      plugin: require('/Users/mo/Desktop/apps/Mo/node_modules/gatsby-plugin-emotion/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/mo/Desktop/apps/Mo/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    }]
